<template>
  <div class="warnings-center">
    <toolbar
      backRoute="/dashboard"
      title="Geneva Monitoring"
      actionButtonLabel="Refresh"
      actionButtonIcon="autorenew"
      :actionButtonCallback="debouncedLoadFilteredData" />

    <d-row class="mt-5 mb-5 px-0">
      <d-col md="12">
        <h4 class="mb-4 d-flex">
          <span>Observed slots</span>

          <d-button
            theme="success"
            outline
            class="ml-auto"
            @click.prevent="addSlot()">
            Add slot
          </d-button>
        </h4>

        <d-alert
          :show="loaded && !slots.length"
          theme="warning"
          class="text-center">
          There are no observed slots...
        </d-alert>

        <d-card
          v-for="(slot, index) of slots"
          :key="'slot-' + index"
          class="px-3 py-2 mb-3">
          <d-row>
            <d-col md="2" class="d-flex align-middle">
              <d-badge
                theme="secondary"
                class="align-items-center px-4 py-2">
                {{ slot.date }}
                <div class="py-1"></div>
                {{ slot.time_from }} - {{ slot.time_to }}
              </d-badge>
            </d-col>
            <d-col md="3" class="align-middle">
              <small>
                ICAO type: <span class="text-primary">{{ slot.icao_type }}</span><br>
                Registration: <span class="text-primary">{{ slot.registration }}</span>
              </small>
            </d-col>

            <d-col md="3" class="align-middle align-items-center py-2">
              <div v-if="slot.hasAvailableSlots">
                Status:
                <div
                  class="AvDft"
                  style="width: 10px; height: 10px; margin: 0 6px 0 3px; display: inline-block; position: relative; top: 1px;">
                </div>
                Slots Available
              </div>
              <div v-else>
                Status:
                <div
                  class="AvNoSlot"
                  style="width: 10px; height: 10px; margin: 0 6px 0 3px; display: inline-block; position: relative; top: 1px;">
                </div>
                No Slots
              </div>
            </d-col>

            <d-col md="4" class="d-flex justify-content-end">
              <d-button
                @click.prevent="viewSlot(slot.id)"
                theme="success"
                :outline="true">
                <i class="material-icons">visibility</i> View
              </d-button>
              <d-button
                @click.prevent="editSlot(slot.id)"
                class="ml-2"
                :outline="true">
                <i class="material-icons">edit</i> Edit
              </d-button>
              <d-button
                theme="danger"
                @click.prevent="removeSlot(slot.id)"
                :outline="true"
                class="ml-2"
                :disabled="removeInProgress">
                <i class="material-icons">delete</i> Remove
              </d-button>
            </d-col>
          </d-row>
        </d-card>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'monitoring',
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data () {
    return {
      loaded: false,
      slots: null,
      loadError: false,
      search: '',
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
    this.$bus.$on('monitoring-list-reload', this.debouncedLoadFilteredData);

    if (this.$route.params.id) {
      let id = parseInt(this.$route.params.id, 10);
      this.$bus.$emit('show-monitoring-popup', 'view', id);
    }
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      this.loaded = false;

      ListUtils.loadItemsData(this, '/geneva/slots/items', 'slots', {
        pagination: false,
        successAction: () => {
          this.slots = this.slots.map(slot => {
            let availableSlots = slot.observed_hours.filter(hour => hour.html_class.indexOf('AvDft') > -1);
            slot.hasAvailableSlots = !!availableSlots.length;
            return slot;
          });
        }
      });
    },
    addSlot () {
      this.$bus.$emit('show-monitoring-popup', 'add', 0);
    },
    removeSlot (id) {
      if (this.removeInProgress) {
        return;
      }

      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/geneva/slots/delete/',
        id: parseInt(id, 10),
        successTitle: 'Slot removed',
        successText: 'The selected slot has been removed',
        confirmTitle: 'Do you really want to remove this slot?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        timer: 1000,
        timerProgressBar: true,
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('monitoring-list-reload');
          this.$bus.$emit('topbar-get-notifications');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    editSlot (id) {
      this.$bus.$emit('show-monitoring-popup', 'edit', id);
    },
    viewSlot (id) {
      this.$bus.$emit('show-monitoring-popup', 'view', id);
    }
  },
  beforeDestroy () {
    this.$bus.$off('monitoring-list-reload', this.debouncedLoadFilteredData);
  }
};
</script>

<style lang="scss" scoped>
.AvNoSlot {
  background: red;
  color: red;
}

.AvDft {
  background: green;
  color: green;
}

.AvDep {
  background: orange;
  color: orange;
}

.AvArr {
  background: violet;
  color: violet;
}

.AvAllLockedAllAccessible {
  background: blue;
  color: blue;
}
.AvAllLockedDepAccessible {
  background: darkblue;
  color: darkblue;
}

span.AvNoSlot,
span.AvDft,
span.AvDep,
span.AvArr,
span.AvAllLockedAllAccessible,
span.AvAllLockedDepAccessible {
  background: transparent;
}
</style>
